import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
export default function IncomeStats() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [seletedGymId, setSeletedGymId] = useState("");
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const { currentUser } = useSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await get(`${endpoints.pass}/authorize/list`);
      if (response && response.data) {
        setData(response.data.data || []);
        setTotalAmount(response.data.totalAmount || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getScale = (amount) => {
    if (amount <= 100) return 100;
    if (amount <= 1000) return 1000;
    if (amount <= 10000) return 10000;
    return Math.pow(10, Math.ceil(Math.log10(amount)));
  };

  const calculateStrokeDashoffset = (totalAmount2, circumference) => {
    const scale = getScale(totalAmount2);
    const progress = totalAmount2 / scale;
    return circumference * (1 - progress);
  };
  const circumference = 691.5;
  const totalAmount2 = totalAmount;
  const strokeDashoffset = calculateStrokeDashoffset(
    totalAmount2,
    circumference
  );
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <div>
      <Card className="rounded-4 incomeCard mb-2" style={{ width: "100%" }}>
        <CardBody className="d-flex flex-column justify-content-between">
          <div>
            <CardTitle
              tag="h5"
              className="ff-sora font-size-16 primary-black fw-normal"
            >
              Income Statistics
            </CardTitle>
            <p className="light-black ff-sora font-size-14 fw-normal">
              You’ve increased income for passes from your app.
            </p>
          </div>

          <div className=" d-flex justify-content-center progress-circle position-relative">
            <svg width="350" height="350" viewBox="0 0 250 250">
              {/* Base Circle */}
              <circle
                cx="125"
                cy="125"
                r={110}
                stroke="#f7f7f7"
                strokeWidth={25}
                fill="none"
              />
              {/* Progress Circle */}
              <circle
                cx="125"
                cy="125"
                r={110}
                stroke="rgba(59, 171, 166, 0.35)"
                strokeWidth={25}
                fill="none"
                strokeDasharray={691.5}
                strokeDashoffset={strokeDashoffset}
                strokeLinecap="round"
                transform="rotate(-90 125 125)"
              />
            </svg>
            <div
              className="income-text position-absolute text-center"
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <span className="light-black ff-sora font-size-14 fw-normal">
                Earnings
              </span>
              <br />
              <span className="fw-bold font-size-24 ff-sora primary-black">
                ${formatNumber(totalAmount)}
              </span>
            </div>
          </div>

          {/* Legend */}
          <div className="legend mt-3">
            <Row>
              <Col xs="12" sm="6" className="text-center">
                <span className="ff-sora font-size-14 light-black fw-normal">
                  Earnings from start
                </span>
              </Col>
              <Col xs="12" sm="6" className="text-center">
                <span className="ff-sora font-size-14 light-black fw-normal">
                  Till today
                </span>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
